export const DEFAULT_ANY_OPTION = 'Any'

export const AVAILABLE_STATUS = 'available'
